<template>
  <div class="supenpopup"
       :style="{top:`${elTop}px`,left:`${elLeft}px`,width:`${width}px`,height:`${height}px`,zIndex,right: `${right}px`}"
       @touchmove.prevent.stop="onTouchMove" @touchstart="onTouchStart">
    <!-- 插槽-自定义内容 -->
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Dragged',
  props: {
    //组件高，单位rpx
    height: {
      type: [String, Number],
      default: 50
    },
    //组件宽，单位rpx
    width: {
      type: [String, Number],
      default: 69
    },
    //起始位置距离顶部距离，单位rpx,auto:自动设置，将位于页面最顶端
    top: {
      type: [String, Number],
      default: 'auto'
    },
    //起始位置距离左边距离，单位rpx，auto:自动设置，将位于页面最左边
    // left: {
    // 	type: [String, Number],
    // 	default: 'auto'
    // },
    //层级
    zIndex: {
      type: Number,
      default: 999
    },
    right: {
      type: [String, Number],
      default: '0'
    }
  },
  data() {
    return {
      elTop: 0, //组件距离顶部距离
      elLeft: 0, //组件距离左边距离
      windowHeight: 0, //窗口高度
      windowWidth: 0, //窗口宽度
      rate: 0, //px和rpx换算比例
      windowTop: 0, //窗口距离屏幕顶部距离
      startX: null, //开始移动触摸点x坐标，相对页面左上角
      startY: 0, //开始移动点触摸点y坐标，，相对页面左上角
      startTop: 0, //悬浮框顶部距离顶部距离，小程序相对页面顶部，h5和app相对屏幕顶部
      startLeft: 0, //悬浮窗左边距离页面左边距离
    }
  },
  created() {
    // 获取页面可视区域宽度和高度
    this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // 获取页面距离窗口顶部距离
    this.windowTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.elTop = this.top === 'auto' ? this.windowTop : this.top;
    this.elLeft = this.left === 'auto' ? 0 : this.left;
    this.rate = 750 / this.windowWidth;
  },

  methods: {
    //开始移动
    onTouchStart(e) {
      //记录开始时候触摸点坐标
      this.startX = null   //这里控制只可以上下，x轴0
      this.startY = e.touches[0].clientY

      //记录移动前组件位置
      this.startTop = this.elTop
      this.startLeft = this.elLeft
    },
    //移动中
    onTouchMove(e) {
      // 只上下滑动，左右不滑动，所以把X注释
      // let x = e.touches[0].clientX;

      // //忽略触摸屏幕最左边外面
      // if (x < 0) {
      // 	x = 0;
      // }
      // // console.log('ex',x)
      // // console.log('y',y)
      // //当前组件距离左边位置=开始位置(x轴)+（当前触摸点x坐标-开始移动触摸点x坐标）
      // let elLeft = this.startLeft + (x - this.startX);
      // console.log("elLeft",elLeft)

      // //悬浮窗右边限制移出屏幕外 this.rate单位换算比例，windowWidth单位px，width单位rpx
      // //屏幕宽度-组件宽度=组件最大向左可移动距离（elLeft）
      // //可移动范围elLeft值限制在0~（this.windowWidth - this.width / this.rate）范围内
      // elLeft = Math.min(elLeft, this.windowWidth - this.width / this.rate)
      // console.log('elLeft',elLeft)
      // this.elLeft = elLeft > 0 ? elLeft : 0
      let y = e.touches[0].clientY;
      //忽略触摸屏幕最顶部外面
      if(y < 0) {
        y = 0;
      }
      let elTop = this.startTop + (y - this.startY);
      console.log("elTop", elTop)

      //悬浮窗限制移出屏幕底部
      //可移动范围elTop值限制在this.windowTop~（this.windowHeight - this.height / this.rate + this.windowTop）范围内
      elTop = Math.min(elTop, this.windowHeight - this.height / this.rate + this.windowTop)
      //悬浮窗限制移到导航栏上或移出屏幕顶部
      this.elTop = Math.max(elTop, this.windowTop)
    },
  }
};
</script>

<style scoped>
/* scoped样式 */
.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.floating-button:hover {
  transform: scale(1.1);
}

.supenpopup {
  /* background-color: pink; */
  position: absolute;
}
</style>
